<template>
    <div style="padding:0 82px">
        <div>{{ $t('integration.level_alarm') }}</div>
        <el-divider></el-divider>
        <div class="levelPage">
            <!-- 层级区域 -->
            <div class="leftList">
                <div class="level">
                    <!-- 左侧层级 -->
                    <ul>
                        <li
                            class="publicClass"
                            :class="index === active ? 'active' : ''"
                            v-for="(item, index) in alarmTriggerHierarchyList"
                            :key="index"
                            @dragstart="drag($event, item)"
                            @dragend="handleDragEnd($event, item)"
                            @dragover.prevent="handleDragOver($event, item)"
                            @dragenter="handleDragEnter($event, item)"
                            draggable="true"
                            @click="handleCLick(item, index)"
                        >
                            {{ item.name }}
                            <i class="el-icon-delete" @click="delRow(index, item)"></i>
                        </li>
                    </ul>
                </div>
                <div class="addLevel publicClass" @click="addRow">
                    <i class="el-icon-plus"></i>
                </div>
            </div>
            <!-- 层级内容 -->
            <div class="rightContent">
                <div class="mb15">
                    <el-input
                        v-model="alarmTriggerHierarchyList[active].name"
                        type="text"
                        maxlength="50"
                        :placeholder="$t('integration.please_enter_the_level_name')"
                        style="width:250px"
                        @input="inputValueFn"
                    >
                    </el-input>
                </div>
                <!-- 层级延迟 -->
                <div class="levelDelay mb15">
                    <!-- 因为语序不一样 所以I18N也需要有所调整 -->
                    <!-- 中文 -->
                    <template v-if="getLanguage() === 'zh_CN'">
                        <div v-for="item in alarmTriggerHierarchyList[active].abnormalDelayList" :key="item.id" class="levelC">
                            <div class="levelDiv">{{ item.type | filterFn }}</div>
                            <div class="abDelay">
                                <el-input @blur="blurNumberFn(item.delayNum)" style="width:60px" type="text" v-model="item.delayNum"></el-input>
                            </div>
                            <div class="abDelay">
                                <el-select v-model="item.unit" :placeholder="$t('public.please')" style="width:80px">
                                    <el-option v-for="item in selectArray" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                                </el-select>
                            </div>
                            <div class="levelDiv">{{ $t('integration.rear_alarm') }}</div>
                        </div>
                    </template>

                    <!-- 英文状态 -->
                    <template v-else>
                        <div v-for="item in alarmTriggerHierarchyList[active].abnormalDelayList" :key="item.id" class="levelC">
                            <div class="levelDiv">After</div>
                            <div class="abDelay">
                                <el-input @blur="blurNumberFn(item.delayNum)" style="width:60px" type="text" v-model="item.delayNum"></el-input>
                            </div>
                            <div class="abDelay">
                                <el-select v-model="item.unit" :placeholder="$t('public.please')" style="width:80px">
                                    <el-option v-for="item in selectArray" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                                </el-select>
                            </div>
                            <div class="levelDiv">Alarm {{ item.type | filterFn }}</div>
                        </div>
                    </template>
                </div>
                <!-- 延迟报警对象 -->
                <div class="alarm_obj">
                    <div class="obj_header mb15">
                        <span class="obj_span">{{ $t('alarm.alarm_object') }}</span>
                        <span class="obj_icon">
                            <i
                                class="el-icon-user"
                                :title="$t('integration.whether_to_automatically_save_the_alarm_object_to_the_contact')"
                                :class="userShow ? 'isOrange' : ''"
                                @click="activeUserFn"
                            ></i>
                            <i class="el-icon-plus" @click="addUerFn"></i>
                        </span>
                    </div>
                    <div class="obj_table">
                        <el-form :model="alarmTriggerHierarchyList[active].dioForm" :rules="rules" ref="form">
                            <el-table
                                stripe
                                ref="multipleTable"
                                :data="alarmTriggerHierarchyList[active].dioForm.tableData"
                                tooltip-effect="dark"
                                style="width: 100%"
                                :show-header="false"
                                max-height="200"
                            >
                                <el-table-column prop="name" show-overflow-tooltip>
                                    <template #default="{ row, $index }">
                                        <el-form-item :prop="'tableData.' + $index + '.' + 'name'" :rules="rules['name']">
                                            <i @click="handleChoozeFn(active, $index, '0', row)" class="el-icon-message" :class="startFn(row.alarmWay, '0')" :title="titleFn(row.alarmWay, '0')"></i>

                                            <i
                                                @click="handleChoozeFn(active, $index, '1', row)"
                                                class="el-icon-chat-dot-round"
                                                :class="startFn(row.alarmWay, '1')"
                                                :title="titleFn(row.alarmWay, '1')"
                                            ></i>

                                            <i @click="handleChoozeFn(active, $index, '2', row)" class="el-icon-microphone" :class="startFn(row.alarmWay, '2')" :title="titleFn(row.alarmWay, '2')"></i>
                                            <span>
                                                <el-select
                                                    v-model="row.name"
                                                    :placeholder="$t('integration.please_enter/select_a_contact_person')"
                                                    style="width:150px"
                                                    @change="changFn($event, $index)"
                                                    filterable
                                                    allow-create
                                                    default-first-option
                                                >
                                                    <el-option v-for="item in userArray" :key="item.name" :label="item.name" :value="item.name"> </el-option>
                                                </el-select>
                                            </span>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="phone" show-overflow-tooltip>
                                    <template #default="{ row, $index }">
                                        <el-form-item :prop="'tableData.' + $index + '.' + 'phone'" :rules="rules['phone']">
                                            <el-input type="text" v-model="row.phone" style="width:200px" :placeholder="$t('integration.please_enter_the_number')"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="email" show-overflow-tooltip>
                                    <template #default="{ row, $index }">
                                        <el-form-item :prop="'tableData.' + $index + '.' + 'email'" :rules="rules['email']">
                                            <el-input type="text" v-model="row.email" style="width:200px" :placeholder="$t('integration.please_enter_email')"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="optare" width="60px" align="right">
                                    <template #default="{ $index }">
                                        <el-form-item>
                                            <i class="el-icon-delete" @click="delUserFn($index)"></i>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { alarmContactsList } from '@/api/modules/alarm.js';
import { getLanguage } from '@/lang';
export default {
    props: ['delayArrayParent', 'ContactsList', 'LevelContentArray'],
    watch: {
        // 数据的回显
        LevelContentArray(newVal) {
            const array = JSON.parse(JSON.stringify(newVal));
            this.alarmTriggerHierarchyList = array.map(item => {
                item.abnormalDelayList = JSON.parse(item.delayData);
                item.dioForm = {
                    tableData: JSON.parse(item.alarmObject)
                };

                // console.log(item);
                return item;
            });
        },
        delayArrayParent(newVal) {
            this.alarmTriggerHierarchyList.forEach((item, i) => {
                newVal.forEach((opt, j) => {
                    if (i === j) {
                        item.abnormalDelayList = opt.delayData;
                    }
                });
            });
        },
        ContactsList(newVal) {
            this.userArray = [...newVal];
        }
    },
    filters: {
        filterFn(value) {
            switch (String(value)) {
                case '0': {
                    return $t('public.ex_conn');
                }
                case '1': {
                    return $t('public.ex_data');
                }
                case '2': {
                    return $t('public.ex_power');
                }
                default:
                    break;
            }
        }
    },
    computed: {
        rules() {
            return {
                name: [
                    { required: true, message: $t('integration.contact_cannot_be_empty'), trigger: ['blur', 'change'] },
                    {
                        max: 50,
                        trigger: ['blur', 'change'],
                        message: $t('integration.length_within_50')
                    }
                ],
                phone: [
                    { required: true, message: $t('integration.phone_number_cannot_be_empty'), trigger: ['blur', 'change'] },
                    {
                        max: 20,
                        trigger: ['blur', 'change'],
                        message: $t('integration.length_within_20')
                    }
                ],
                email: [
                    { required: true, message: $t('integration.please_enter_email_address'), trigger: ['blur', 'change'] },
                    {
                        max: 255,
                        trigger: ['blur', 'change'],
                        message: $t('integration.length_within_255')
                    },
                    { type: 'email', message: $t('integration.please_enter_the_correct_email_address'), trigger: ['blur', 'change'] }
                ]
            };
        }
    },
    data() {
        return {
            getLanguage,
            active: 0,
            alarmTriggerHierarchyList: [
                {
                    name: $t('alarm.default_layer'),

                    abnormalDelayList: [],
                    dioForm: {
                        tableData: [
                            {
                                alarmWay: '',
                                name: '',
                                phone: '',
                                email: ''
                            }
                        ]
                    }
                }
            ],
            userShow: false,
            // 新增行时候自动戴上
            // abnormalDelayList: [],
            selectArray: [
                {
                    value: 0,
                    label: $t('public.second')
                },
                {
                    value: 1,
                    label: $t('public.minute')
                },
                {
                    value: 2,
                    label: $t('public.hour')
                }
            ],
            iconArray: [
                {
                    id: '0',
                    icon: 'el-icon-message',
                    label: $t('integration.click_to_enable_email_alarm'),
                    activeLabel: $t('integration.click_to_close_the_email_alarm')
                },
                {
                    id: '1',
                    icon: 'el-icon-chat-dot-round',
                    label: $t('integration.click_to_enable_sms_alarm'),
                    activeLabel: $t('integration.click_to_close_sms_alarm')
                },
                {
                    id: '2',
                    icon: 'el-icon-microphone',
                    label: $t('integration.click_to_enable_voice_alarm'),
                    activeLabel: $t('integration.click_to_close_the_voice_alarm')
                }
            ],
            // 联系人
            userArray: []
        };
    },
    created() {
        // console.log(this.alarmTriggerHierarchyList,123231);
        if (this.$store.state.type !== 2 && this.$store.state.type !== 3) {
            console.log(this.$store.state);
            alarmContactsList({ sceneId: this.$store.state.userInfo.scope.sceneId }).then(({ result }) => {
                this.userArray = result;
            });
        }
    },
    methods: {
        opteraData(e, obj) {
            console.log(e, obj, this.alarmTriggerHierarchyList);
            if (!e) {
                this.alarmTriggerHierarchyList.forEach(item => {
                    item.abnormalDelayList = item.abnormalDelayList.filter(opt => String(opt.type) !== obj.type);
                });
                return;
            }

            this.alarmTriggerHierarchyList.forEach(item => {
                item.abnormalDelayList.push(obj);
            });
        },
        generOdd(filterData) {
            const obj = {};
            // 2 数组去重
            filterData = filterData.reduce((pre, cur) => {
                obj[cur.type] ? '' : (obj[cur.type] = true && pre.push(cur));
                return pre;
            }, []);
            return filterData;
        },
        clearValidate() {
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate();
                }
            });
        },
        resetFn(isClear = false) {
            this.alarmTriggerHierarchyList.forEach(item => {
                (item.dioForm.tableData = [
                    {
                        alarmWay: '',
                        name: '',
                        phone: '',
                        email: ''
                    }
                ]),
                    !isClear ? (item.abnormalDelayList = []) : '';
            });
            this.clearValidate();
        },
        async justify() {
            try {
                return await this.$refs.form.validate();
            } catch (error) {
                return false;
            }
        },
        async addRow() {
            if (this.alarmTriggerHierarchyList[this.active].name === '') return this.$message.warning($t('integration.level_name_cannot_be_empty'));
            const flag = await this.justify();
            if (!flag) return;
            const newArray = JSON.parse(JSON.stringify(this.alarmTriggerHierarchyList[0].abnormalDelayList));
            const array = newArray.map(item => {
                item.delayNum = '0';
                return item;
            });
            const obj = {
                name: $t('alarm.default_layer'),

                alarmTriggerHierarchyList: [],
                abnormalDelayList: array || [],
                dioForm: {
                    tableData: [
                        {
                            alarmWay: '',
                            name: '',
                            phone: '',
                            email: ''
                        }
                    ]
                }
            };
            this.alarmTriggerHierarchyList.push(obj);
        },
        delRow(index, item) {
            if (this.alarmTriggerHierarchyList.length === 1) return this.$message.warning($t('integration.keep_at_least_one'));
            this.$confirm()
                .then(() => {
                    this.alarmTriggerHierarchyList.splice(index, 1);

                    if (index - 1 < 0) {
                        this.active = index;
                    } else {
                        this.active = index - 1;
                    }
                })
                .catch(() => {});
        },
        inputValueFn(e) {
            this.alarmTriggerHierarchyList[this.active].name = e;
        },
        handleCLick(item, index) {
            this.active = index;
            this.clearValidate();
        },
        drag(ev, item) {
            // 克隆被拖拽元素
            this.dom = item;
        },
        handleDragEnd(ev) {
            this.dom = null;
        },
        // 首先把div变成可以放置的元素，即重写dragenter/dragover
        handleDragOver(e) {
            e.dataTransfer.dropEffect = 'move'; // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
        },
        handleDragEnter(e, item) {
            e.dataTransfer.effectAllowed = 'move'; // 为需要移动的元素设置dragstart事件
            if (item === this.dom) {
                return;
            }
            const newItems = [...this.alarmTriggerHierarchyList];
            const src = newItems.indexOf(this.dom);
            const dst = newItems.indexOf(item);

            newItems.splice(dst, 0, ...newItems.splice(src, 1));

            this.alarmTriggerHierarchyList = newItems;
        },
        startFn(str, num) {
            if (!str) return;
            const array = str.split(',');
            return array.includes(num) ? 'orange' : '';
        },
        titleFn(status, num) {
            let str = '';
            const array = status.split(',');
            for (const item of this.iconArray) {
                if (item.id === num) {
                    str = array.includes(num) ? item.activeLabel : item.label;
                    break;
                }
            }
            return str;
            // return array.includes(num) ?
            //     this.iconArray[num].label
            //     : ''
        },
        // 大于等于0 的整数
        blurNumberFn(num) {
            if (Number(num) < 0 || num === '') return this.$message.warning($t('integration.please_enter_an_integer_greater_than_or_equal_to_0'));
            const reg = /^-?[0-9]\d*$/;
            if (!reg.test(Number(num))) return this.$message.warning($t('integration.please_enter_an_integer'));
            return true;
        },
        addUerFn() {
            this.alarmTriggerHierarchyList[this.active].dioForm.tableData.push({
                alarmWay: '',
                name: '',
                phone: '',
                email: ''
            });
        },
        delUserFn(index) {
            if (this.alarmTriggerHierarchyList[this.active].dioForm.tableData.length === 1) return this.$message.warning($t('integration.keep_at_least_one'));
            this.alarmTriggerHierarchyList[this.active].dioForm.tableData.splice(index, 1);
        },
        handleChoozeFn(active, index, strNum, row) {
            let alarmWayArray = (row.alarmWay && row.alarmWay.split(',')) || [];
            // 存在干掉
            if (alarmWayArray.includes(strNum)) {
                alarmWayArray = alarmWayArray.filter(item => item != strNum);
            } else {
                // 不存在 添加
                alarmWayArray.push(strNum);
            }
            this.$set(row, 'alarmWay', alarmWayArray.join(','));
        },
        activeUserFn() {
            this.userShow = !this.userShow;
        },
        // 选择联系人填充表格数据
        changFn(name, index) {
            let obj = {};
            this.userArray.forEach(opt => {
                if (name === opt.name) {
                    obj = opt;
                }
            });
            this.alarmTriggerHierarchyList[this.active].dioForm.tableData[index].phone = obj.phone;
            this.alarmTriggerHierarchyList[this.active].dioForm.tableData[index].email = obj.email;
        }
    }
};
</script>

<style lang="scss" scoped>
.levelPage {
    display: flex;
}

.leftList {
    width: 200px;
    border: 1px solid #ccc;
    padding: 5px;
    box-sizing: border-box;
    height: 320px;

    .level {
        max-height: calc(100% - 30px);
        overflow: auto;
    }

    .publicClass {
        background-color: #fff;
        width: 100%;
        border-radius: 2px;
        padding: 0 5px;
        margin: 5px 0;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        text-align: center;
        border: 1px solid #ccc;
        box-sizing: border-box;
        cursor: pointer;
    }

    .addLevel {
        font-weight: bold;
    }

    .active {
        color: #fff;
        font-weight: bold;
        background-color: var(--primary-color);

        i {
            color: #fff;
        }
    }

    .el-icon-delete {
        float: right;
        line-height: 30px;
    }
}

.rightContent {
    flex: 1;
    padding: 0 15px;
    box-sizing: border-box;

    .mb15 {
        margin-bottom: 15px;
        font-size: 14px;
    }

    .levelDelay {
        display: flex;
        border-radius: 2px;

        .levelC {
            height: 30px;
            margin-right: 10px;
            display: flex;
            border: 1px solid var(--primary-color);
            // box-sizing: border-box;
            align-content: center;
            justify-content: space-between;
            border-radius: 2px;
        }

        .levelDiv {
            height: 100%;
            padding: 0 5px;
            box-sizing: border-box;
            font-size: 14px;
            line-height: 28px;
            background-color: var(--primary-color);
            color: #fff;
        }

        ::v-deep .abDelay {
            background-color: #fff;
            color: var(--primary-color);
            .el-input__inner,
            .el-select {
                border-radius: 0 !important;
            }

            .el-select {
                margin-left: -1px;
            }
        }
    }

    .alarm_obj {
        .obj_header {
            display: flex;
            justify-content: space-between;
            padding-right: 15px;
        }

        .obj_span {
            font-size: 14px;

            &::before {
                content: '*';
                color: #f56c6c;
                margin-right: 4px;
            }
        }

        .obj_icon {
            i {
                font-size: 14px;
                font-weight: bold;
                margin: 0 5px;
                cursor: pointer;
            }
        }

        .obj_table {
            .orange {
                color: orange;
            }

            i {
                margin-right: 5px;
                cursor: pointer;
                font-size: 14px;
            }
        }

        .isOrange {
            color: orange;
        }
    }

    .el-form-item {
        margin-bottom: 0 !important;
        height: 60px;
        display: flex;
        align-items: center;
    }
}
</style>
